import React, { Fragment } from 'react';
import { Navigate, BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom';
import './index.css';
import Home from 'pages/index';
import ExpiredToken from 'pages/auth/ExpiredToken';
import ResetPassword from 'pages/auth/ResetPassword';
import Login from 'pages/auth/Login';
import Dashboard from 'pages/my-account/Dashboard';
import Work from 'pages/my-account/Work';
import Composer from 'pages/my-account/Composer';
import ReadWork from 'pages/ReadWork';
import Profil from 'pages/my-account/Profil';
import NotFound from "components/404/NotFound";
import MailVerified from 'pages/auth/MailVerify';
import NotVerify from 'pages/auth/NotVerify';
import Redirect from 'pages/Redirect';
import CreateSitemap from 'pages/CreateSiteMap';
import PrivateRoute from "components/auth/PrivateRoute";
import ProposeComposer from 'pages/proposal/ProposeComposer';
import ProposeWork from 'pages/proposal/ProposeWork';

export default function App() {

  return (
    <Router basename={`${process.env.NODE_ENV == "development" ? '/' : '/oppdb'}`}>
      <Fragment>
        <Routes>
          <Route path="/"  element={<Home />} />
          <Route path="/work/:id/:title" exact element={<ReadWork />} ></Route>
          <Route path="/createsitemap/" exact element={<CreateSitemap />} ></Route>

          {/* Auth route */}
          <Route exact path="/auth/resetPassword/" element={<ResetPassword />} /> 
          <Route exact path="/auth/expired-token/" element={<ExpiredToken />} />
          <Route exact path="/auth/verified/" element={<MailVerified />} />
          <Route exact path="/auth/not-verify/" element={<NotVerify />} />
          <Route exact path="/auth/login/*" element={<Login />} />

          {/* Redirect route */}
          <Route exact path="/redirect/" element={<Redirect />} />
          
          {/* Require auth user route  IIH-754-90578 */} 
          <Route exact path='/app/dashboard' element={<PrivateRoute/>}>
            <Route exact path='/app/dashboard' element={<Dashboard/>}/>
          </Route>

          <Route exact path='/app/composer' element={<PrivateRoute/>}>
            <Route exact path='/app/composer' element={<Composer/>}/>
            <Route exact path='/app/composer/propose/:id' element={<ProposeComposer/>}/>
          </Route>

          <Route exact path='/app/work' element={<PrivateRoute/>}>
            <Route exact path='/app/work' element={<Work/>}/>
            <Route exact path='/app/work/propose/:id' element={<ProposeWork/>}/>
          </Route>

          <Route exact path='/app/profil' element={<PrivateRoute/>}>
            <Route exact path='/app/profil' element={<Profil/>}/>
          </Route>
          
          <Route  path="*" element={<NotFound />} />
        </Routes>
      </Fragment>
    </Router>
  );
}